"use client";

import { clearRememberedStorageScope } from "@/lib/sync/storage-scope";

const EXACT_KEYS_TO_REMOVE = [
  "rememberedSetCounts",
  "defaultSets",
  "defaultWarmupSets",
  "defaultReps",
  "defaultRestSeconds",
  "resetSetsAfterWorkout",
  "weightStepKg",
  "weightStepLbs",
  "workoutWeightStepKg",
  "workoutWeightStepLbs",
  "weightComparisonDays",
  "rpeTrackingEnabled",
  "daily_routine_settings_cache",
  "daily_routine_last_shown",
  "preferredMeasurementUnit",
  "measurement_latest_cache",
  "measurement_config_cache",
  "measurementStepCm",
  "measurementStepIn",
  "clientSavedRoute",
  "clientSavedRouteHref",
  "clientSavedRouteTimestamp",
] as const;

const PREFIXES_TO_REMOVE = [
  "daily_routine_last_shown_",
  "measurement_config_cache_",
  "measurementStepCm_",
  "measurementStepIn_",
  "defaultRestSeconds_",
] as const;

export function clearUserLocalStorage(targetStorage?: Storage): void {
  const storageRef =
    targetStorage ?? (typeof window !== "undefined" ? window.localStorage : null);
  if (!storageRef) return;

  for (const key of EXACT_KEYS_TO_REMOVE) {
    storageRef.removeItem(key);
  }

  const prefixedKeys: string[] = [];
  for (let index = 0; index < storageRef.length; index += 1) {
    const key = storageRef.key(index);
    if (!key) continue;
    if (PREFIXES_TO_REMOVE.some((prefix) => key.startsWith(prefix))) {
      prefixedKeys.push(key);
    }
  }

  for (const key of prefixedKeys) {
    storageRef.removeItem(key);
  }

  clearRememberedStorageScope(storageRef);
}
